import React from 'react';
import { X } from 'lucide-react';
import './Modal.css';

const WELCOME_SEEN_KEY = 'press_welcome_seen';

export function hasSeenWelcome() {
  try {
    const seen = localStorage.getItem(WELCOME_SEEN_KEY);
    // Version-based: show again on new builds so release notes surface
    return seen === __APP_VERSION__;
  } catch {
    return false;
  }
}

function WelcomeModal({ onClose, onOpenDiscord }) {
  const handleDismiss = () => {
    try {
      localStorage.setItem(WELCOME_SEEN_KEY, __APP_VERSION__);
    } catch { /* ignore */ }
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={handleDismiss}>
      <div className="modal-content confirm-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '440px' }}>
        <div className="modal-header">
          <h2>Welcome to Press2DN!</h2>
          <button className="close-btn" onClick={handleDismiss}>
            <X size={24} />
          </button>
        </div>

        <div className="confirm-content" style={{ textAlign: 'left' }}>
          <p style={{ marginBottom: '0.75rem' }}>
            Press2DN is built for golf trips and tracking matches.
            Set up match play, stableford, skins, closest to the pin for a single round or across an entire trip.
            Track presses in real time, follow a live leaderboard, and settle up at the end.
          </p>
          <p>
            Questions or feedback? Join the conversation on our{' '}
            <a
              href="#"
              onClick={(e) => { e.preventDefault(); onOpenDiscord?.(); }}
              style={{ color: 'var(--accent-primary)', fontWeight: 600, textDecoration: 'none' }}
            >Discord</a>.
          </p>
        </div>

        <div className="modal-actions" style={{ justifyContent: 'center' }}>
          <button type="button" className="btn-primary" onClick={handleDismiss}>
            Let's Go
          </button>
        </div>
      </div>
    </div>
  );
}

export default WelcomeModal;
